import React from "react";

const ReplyInput = ({
  user,
  setComment,
  setReply,
  comment,
  handleSubmit,
  el,
  reply,
}) => {
  return (
    <div className="relative mt-4 z-20 border-t border-black dark:border-white/30 bg-[#f4f4f4] dark:bg-[#111] p-4">
      <span className="bg-black text-white px-2 py-1 text-[8px] font-mono tracking-widest font-bold uppercase mb-4 inline-block">
        REPLY MODULE ACTIVE
      </span>

      <div className="bg-white dark:bg-black border sm:border-2 border-black dark:border-white/30 focus-within:ring-0 focus-within:bg-gray-50 transition-all shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] dark:shadow-[4px_4px_0px_0px_rgba(255,255,255,0.5)]">
        <div className="flex items-start">
          <textarea
            className="w-full resize-none outline-none bg-transparent text-black dark:text-white font-mono text-sm px-4 py-4 placeholder-gray-400 uppercase font-bold min-h-[100px]"
            name="reply"
            id="reply"
            placeholder={`AWAITING INPUT TO ${el.user_id?.name}...`}
            onChange={(e) => setComment(e.target.value)}
            value={comment}
            autoFocus
          ></textarea>
        </div>

        <div className="flex items-center justify-end px-4 py-3 border-t-2 border-black dark:border-white/30 bg-white dark:bg-black">
          <button
            className="px-4 py-2 text-[10px] font-black font-mono dark:text-white uppercase tracking-widest text-black hover:bg-black hover:text-white transition-colors mr-2 border border-black dark:border-white/30 shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] dark:shadow-[2px_2px_0px_0px_rgba(255,255,255,0.5)] active:shadow-none active:translate-x-0.5 active:translate-y-0.5"
            onClick={() => setReply(!reply)}
          >
            ABORT
          </button>
          <button
            disabled={!comment?.trim()}
            className="px-6 py-2 text-[10px] uppercase tracking-widest font-black font-mono text-white bg-black dark:bg-white dark:text-black hover:bg-red-600 disabled:bg-gray-300 disabled:text-gray-500 disabled:cursor-not-allowed transition-colors border border-black shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] disabled:shadow-none"
            onClick={() => handleSubmit(el)}
          >
            TRANSMIT
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReplyInput;
